// The open tab's create button ("Define Tier", "Define Sites Color"…), in its table's toolbar
function findCreateButton() {
	return [...document.querySelectorAll('main button')].find(b => /^Define\b/.test(b.textContent.trim())) || null
}

const ES = navigator.language?.startsWith('es')

export const TOUR_STEPS = [
	{
		type: 'intro',
		icon: 'gear',
		title: ES ? 'Bienvenido a Ajustes de usuario' : 'Welcome to User Settings',
		description: ES
			? 'Configura tus preferencias personales en seis secciones: Tiers (grupos de proveedores), grupos de oficinas, grupos de sitios, grupos de proveedores web, colores de sitios web y colores de elementos (ACRISS y Categorías). Todos los ajustes se guardan en tu perfil y se aplican en toda la plataforma.'
			: 'Configure your personal preferences across six sections: Tiers (provider groups), office groups, site groups, web supplier groups, website colors, and item colors (ACRISS & Categories). All settings are saved to your profile and used across the platform.',
	},
	{
		type: 'field',
		findTarget: () => {
			return document.querySelector('main .MuiTabs-root') || document.querySelector('.MuiTabs-root')
		},
		icon: 'table-columns',
		title: ES ? 'Pestañas de ajustes' : 'Settings Tabs',
		description: ES
			? 'Navega entre las seis secciones de configuración. «Tiers»: agrupa proveedores en niveles personalizados. «Office group»: agrupa oficinas para filtrado masivo. «Site group»: agrupa sitios web. «Web supplier groups»: agrupa proveedores web. «Website colors»: asigna colores personalizados a sitios y proveedores para los gráficos. «Item colors»: asigna colores a códigos ACRISS y categorías de vehículos.'
			: 'Navigate between the six configuration sections. "Tiers": group providers into custom tiers. "Office group": group offices for bulk filtering. "Site group": group websites. "Web supplier groups": group web suppliers. "Website colors": assign custom colors to sites and providers for charts. "Item colors": assign colors to ACRISS codes and vehicle categories.',
		example: 'Tiers | Office group | Site group | Web supplier groups | Website colors | Item colors',
	},
	{
		type: 'field',
		findTarget: () => {
			return findCreateButton()
		},
		icon: 'circle-plus',
		title: ES ? 'Crear nuevo elemento' : 'Create New Item',
		description: ES
			? 'Haz clic en este botón para crear una nueva entrada. Se abre un panel lateral con un formulario donde rellenas los datos (nombre, elementos asociados, color, etc.) y guardas. Cada tabla tiene su propio botón de creación en su barra de herramientas («Define Tier», «Define Offices Group»…).'
			: 'Click this button to create a new entry. A side drawer opens with a form where you fill in the details (name, associated items, color, etc.) and save. Each table has its own create button in its toolbar ("Define Tier", "Define Offices Group"…).',
	},
	{
		type: 'field',
		findTarget: () => {
			const btn = findCreateButton()
			return btn?.closest('[class*="MUIDataTable-paper"]') || btn?.closest('.MuiPaper-root') || null
		},
		icon: 'table-cells',
		title: ES ? 'Tabla de ajustes' : 'Settings Table',
		description: ES
			? 'Tus configuraciones guardadas se muestran en una tabla. Los Tiers muestran nombre y proveedores asociados. Los grupos de oficinas, sitios y proveedores web muestran nombre y elementos agrupados. Las pestañas de colores muestran nombre y un cuadrado de color con el código hexadecimal. Usa el buscador integrado para encontrar entradas específicas.'
			: 'Your saved configurations are displayed in a table. Tiers show name and associated providers. Office, site and web supplier groups show name and grouped items. Color tabs show name and a colored square with the hex code. Use the built-in search to find specific entries.',
	},
	{
		type: 'field',
		findTarget: () => {
			const icon = document.querySelector('.fa-pen') || document.querySelector('[data-icon="pen"]')
			if (icon) {
				const btn = icon.closest('button')
				if (btn?.parentElement) {
					const row = btn.parentElement
					if (row.children.length >= 2) return row
				}
				return btn
			}
			return null
		},
		skipIf: () => !document.querySelector('.fa-pen') && !document.querySelector('[data-icon="pen"]'),
		icon: 'pen-to-square',
		title: ES ? 'Acciones de editar y eliminar' : 'Edit & Delete Actions',
		description: ES
			? 'Cada fila tiene botones de acción. Editar (icono de lápiz): abre el panel lateral con los valores actuales precargados para que puedas actualizarlos. Eliminar (icono de papelera): borra la entrada tras confirmación. Los cambios se guardan inmediatamente.'
			: 'Each row has action buttons. Edit (pencil icon): opens the side drawer with the current values pre-filled so you can update them. Delete (trash icon): removes the entry after confirmation. Changes are saved immediately.',
		example: ES
			? '✏️ Editar | 🗑️ Eliminar'
			: '✏️ Edit | 🗑️ Delete',
	},
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo listo!' : "You're All Set!",
		description: ES
			? 'Cambia entre pestañas para gestionar los distintos ajustes. Crea tiers para agrupar proveedores y filtrar, organiza oficinas y sitios en grupos, y asigna colores personalizados para una mejor visualización en los gráficos de toda la plataforma.'
			: 'Switch between tabs to manage different settings. Create tiers to group providers for filtering, organize offices and sites into groups, and assign custom colors for better chart visualization across the platform.',
	},
]
